// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import moment from "moment";
import translationEN from "../assets/locales/en.json";
import translationES from "../assets/locales/es.json";
import translationFR from "../assets/locales/fr.json";
import translationGR from "../assets/locales/gr.json";
import translationAL from "../assets/locales/al.json";
import { KEYS, setStorageKey, getStorageKey } from "../utils/storage";

export const appMoment = moment;

// the translations
const resources = {
  en: { translation: translationEN },
  es: { translation: translationES },
  fr: { translation: translationFR },
  gr: { translation: translationGR },
  al: { translation: translationAL },
};

const storedLanguage = getStorageKey(KEYS.LANGUAGE) || "al";

i18n.use(initReactI18next).init({
  resources,
  lng: storedLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  cleanCode: true,
  react: {
    useSuspense: false,
  },
});

export const getLanguage = () => i18n.language;

export const setLanguage = async (lang) => {
  setStorageKey(KEYS.LANGUAGE, lang);
  appMoment.locale(lang);
};

export default i18n;
